import React from "react";
import { Table, Tag, Button, Space, Popconfirm, Tooltip } from "antd";
import dayjs from "dayjs";

function formatDate(d) {
  if (!d) return "—";
  return dayjs(d).format("YYYY-MM-DD");
}

function formatDateTime(d) {
  if (!d) return "—";
  return dayjs(d).format("YYYY-MM-DD HH:mm");
}

function UserListTable({
  users,
  currentAdminId,
  onEditLicense,
  onResetPassword,
  onDelete,
  onRestore,
}) {
  const columns = [
    {
      title: "ID",
      dataIndex: "id",
      key: "id",
      width: 60,
      sorter: (a, b) => a.id - b.id,
    },
    {
      title: "이름",
      dataIndex: "name",
      key: "name",
      sorter: (a, b) => (a.name || "").localeCompare(b.name || ""),
      render: (name, record) => (
        <Space size={6}>
          <span>{name || "—"}</span>
          {record.deleted_at && <Tag color="red">삭제됨</Tag>}
          {record.role === "admin" && <Tag color="blue">관리자</Tag>}
        </Space>
      ),
    },
    {
      title: "이메일",
      dataIndex: "email",
      key: "email",
      sorter: (a, b) => a.email.localeCompare(b.email),
    },
    {
      title: "회원유형",
      dataIndex: "membership_type",
      key: "membership_type",
      width: 90,
      filters: [
        { text: "개인", value: "개인" },
        { text: "기관", value: "기관" },
      ],
      onFilter: (value, record) => record.membership_type === value,
    },
    {
      title: "소속",
      dataIndex: "affiliation",
      key: "affiliation",
      ellipsis: true,
    },
    {
      title: "KLA 만료",
      dataIndex: "kla_expiration",
      key: "kla_expiration",
      width: 110,
      sorter: (a, b) =>
        new Date(a.kla_expiration || 0) - new Date(b.kla_expiration || 0),
      render: formatDate,
    },
    {
      title: "SLE 만료",
      dataIndex: "sle_expiration",
      key: "sle_expiration",
      width: 110,
      sorter: (a, b) =>
        new Date(a.sle_expiration || 0) - new Date(b.sle_expiration || 0),
      render: formatDate,
    },
    {
      title: "분석 건수",
      dataIndex: "analysis_count",
      key: "analysis_count",
      width: 90,
      align: "right",
      sorter: (a, b) => (a.analysis_count || 0) - (b.analysis_count || 0),
      render: (n) => (n > 0 ? n : <span style={{ color: "#bbb" }}>0</span>),
    },
    {
      title: "최근 접속",
      dataIndex: "last_login_at",
      key: "last_login_at",
      width: 140,
      sorter: (a, b) =>
        new Date(a.last_login_at || 0) - new Date(b.last_login_at || 0),
      render: formatDateTime,
    },
    {
      title: "액션",
      key: "actions",
      width: 260,
      render: (_, record) => {
        const isSelf = record.id === currentAdminId;
        const isDeleted = !!record.deleted_at;
        return (
          <Space size={4} wrap>
            <Button size="small" onClick={() => onEditLicense(record)}>
              라이센스
            </Button>
            <Button size="small" onClick={() => onResetPassword(record)}>
              비밀번호
            </Button>
            {isDeleted ? (
              <Popconfirm
                title={`${record.email} 을(를) 복원하시겠습니까?`}
                okText="복원"
                cancelText="취소"
                onConfirm={() => onRestore(record)}
              >
                <Button size="small" type="primary">
                  복원
                </Button>
              </Popconfirm>
            ) : isSelf ? (
              <Tooltip title="본인 계정은 삭제할 수 없습니다.">
                <Button size="small" danger disabled>
                  삭제
                </Button>
              </Tooltip>
            ) : (
              <Popconfirm
                title={`${record.email} 을(를) 삭제하시겠습니까?`}
                description="회원의 로그인이 즉시 차단됩니다. 복원 가능."
                okText="삭제"
                cancelText="취소"
                okButtonProps={{ danger: true }}
                onConfirm={() => onDelete(record)}
              >
                <Button size="small" danger>
                  삭제
                </Button>
              </Popconfirm>
            )}
          </Space>
        );
      },
    },
  ];

  return (
    <Table
      rowKey="id"
      columns={columns}
      dataSource={users}
      size="small"
      pagination={{ pageSize: 20, showSizeChanger: true }}
      scroll={{ x: 1100 }}
    />
  );
}

export default UserListTable;
